import { TradeListState } from './reducer'

export const getTradeList = (state: { tradeList: TradeListState }) =>
  state.tradeList.tradeList

export const getTradeListLoader = (state: { tradeList: TradeListState }) =>
  state.tradeList.isLoading
